import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { Notificationtype, SortDirection, CursorMode } from './Enums'
/**
* Class NotificationsListRequestQuery
*  Query params for operation "NotificationsList"
*/
export class NotificationsListRequestQuery extends ActiveModel {

/**
  * ['Filter.CreatedBefore']
  * Фильтр по дате создания (не позднее, не включая)<br>
  */
  @ActiveField()
  ['Filter.CreatedBefore']?: string


/**
  * ['Filter.CreatedAfter']
  * Фильтр по дате создания (не раньше, включительно)<br>
  */
  @ActiveField()
  ['Filter.CreatedAfter']?: string


  /**
  * ['Filter.Viewed']
  * Фильтр по состоянию просмотра уведомления пользователем: <br>true - только просмотренные; <br>false - только не просмотренные<br>  */
  @ActiveField()
  ['Filter.Viewed']?: boolean


  /**
  * ['Filter.Delivered']
  * Фильтр по состоянию доставки уведомления до пользователя хотя бы через один из каналов распространения: <br>true - только доставленные; <br>false - только не доставленные<br>  */
  @ActiveField()
  ['Filter.Delivered']?: boolean


/**
  * ['Filter.Types']
  * Фильтр по типам уведомлений.<br>Если null или пустой список, то вернуть все типы<br>  */
  @ActiveField({
    setter(model: NotificationsListRequestQuery, prop: string, value: Array<Notificationtype> | undefined, receiver?: NotificationsListRequestQuery ) {
      return Reflect.set(
        model,
        prop,
        value ?  (Array.isArray(value) ? value : [value]) : value, 
        receiver)
    }
  })
  ['Filter.Types']?: Array<Notificationtype>


/**
  * Query
  * Поисковый запрос<br>
  */
  @ActiveField()
  Query?: string


  /**
  * Limit
  * Кол-во элементов в результате. <br><br>Если значение меньше 1, то вернуть все элементы<br>  */
  @ActiveField()
  Limit?: number


/**
  * SortField
  * Поле для сортировки<br>
  */
  @ActiveField()
  SortField?: string


  /**
  * SortDirection
  * Направление сортировки<br>  */
  @ActiveField()
  SortDirection?: SortDirection


  /**
  * CursorMode
  * Режим курсора. Если значение указано, то необходимо<br>указывать Web.Core.Pagination.SortOptions.CursorField и Web.Core.Pagination.SortOptions.CursorId  */
  @ActiveField()
  CursorMode?: CursorMode


/**
  * CursorField
  * Значение Web.Core.Pagination.SortOptions.SortField первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorField?: string


/**
  * CursorId
  * Значение уникального ключа (чаще всего, но не обязательно, это id) первого/последнего элемента<br>(в зависимости от курсора Web.Core.Pagination.SortOptions.CursorMode),<br>полученное в рамках ответа на предыдущий курсорный запрос<br>
  */
  @ActiveField()
  CursorId?: string
}
